export enum RefStatutCode {
    EnCours = 'ENCOURS',
    Habilite = 'HABILITE',
    Refuse = 'REFUSE',
    Retire = 'RETIRE'
}
